import { groq } from 'next-sanity';

const imageField = groq`
  "image": {
    ...image,
    "asset": image.asset->
  }
`;

export const basePostFields = groq`
  "id": _id,
  "createdAt": _createdAt,
  title,
  summary,
  "slug": slug.current,
  ${imageField},
  author->{
    name
  },
  biCode,
  lillyCode
`;

export const categoryFields = groq`
  "id": _id,
  name,
  description,
  "slug": slug.current,
  ${imageField},
  seoData
`;

export const authorFields = groq`
  "id": _id,
  "createdAt": _createdAt,
  name,
  "photo": {
    ...photo,
    "asset": photo.asset->
  },
  profile,
  "slug": slug.current,
  seoData
`;

export const postNextPrevFields = groq`
  title,
  "slug": slug.current
`;

export const postFields = groq`
  ${basePostFields},
  category->{
    ${categoryFields}
  },
  content
`;
